import React from 'react';
// import { FaUsers } from 'react-icons/fa6';
import { MdKeyboardArrowLeft } from 'react-icons/md';
import { useSelector } from 'react-redux';

const HeadingApp = ({ nameTab, title, subTitle, icon }) => {
  const { currentLang } = useSelector((state) => state.user);
  return (
    <>
      <div className="mb-[27px] flex items-center gap-2">
        <span className="text-[#5F5F5F] font-[500] text-[16px]">{nameTab}</span>
        <span>
          {' '}
          <MdKeyboardArrowLeft
            style={{
              transform:
                currentLang === 'en' ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
          />
        </span>
        <span className="text-[#5F5F5F] font-[500] text-[16px]">{title}</span>
        <span>
          {' '}
          <MdKeyboardArrowLeft
            style={{
              transform:
                currentLang === 'en' ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
          />
        </span>
        <span className="text-[#1A1A1A] font-[700] text-[16px]">
          {subTitle}
        </span>
      </div>
      <div
        className="bg-[#FFFFFFA3] py-[24px] px-[32px]"
        style={{
          boxShadow: '0px 2px 0px 0px #0000000F ',
          borderRadius: '16px 16px 0px 0px',
          marginBottom: '7px',
        }}
      >
        <div className="flex items-center gap-[24px]">
          <div className="p-4 bg-[#fff] rounded-[8px]">
            <span className="text-[#079661] text-[30px]">{icon}</span>
            {/* <FaUsers className="text-[#079661] text-[30px]" /> */}
          </div>
          <div className="">
            <h1 className="text-[#1A1A1A] font-[700] text-[20px] leading-12">
              {subTitle}
            </h1>
            <p className="text-[#818181] font-[500] text-[12px]">{title}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeadingApp;
